import { render, staticRenderFns } from "./Step3Others.vue?vue&type=template&id=2555a73c&scoped=true"
import script from "./Step3Others.vue?vue&type=script&lang=js"
export * from "./Step3Others.vue?vue&type=script&lang=js"
import style0 from "./Step3Others.vue?vue&type=style&index=0&id=2555a73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555a73c",
  null
  
)

export default component.exports